// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"5093d70a","135":"4fa45b17","376":"832e1076","407":"3417a970","442":"f517e424","449":"53224381","488":"9d6cbbd5","583":"af7e30a0","613":"87886fe3","618":"290cd7c7","709":"a0b6f51a","808":"82506297","840":"b92c9e63","972":"f6e5fa5d"}[chunkId] + ".chunk.js";
};